<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>Printing Form</h6>
        <p class="mt-0 mb-0">
          <!-- Booking should be apply up to 10 days before you will use or promote event -->
          <!-- In case of booking a car after working hours, the admin will arrange
          the car within working hours of the following day (9:00 - 16:00). -->
        </p>
        <p class="mt-0 mb-0">
          For urgent matter, please contact 02-700-5000 Ext.3102
        </p>
      </template>

      <a-form :layout="'horizontal'" :form="form">
        <a-form-item label="Email" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_mail" placeholder="enter email ..." v-decorator="[
            'contact_mail',
            { initialValue: formData.contact_mail, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Contact" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_tel" placeholder="enter contact ..." v-decorator="[
            'formData.contact_tel',
            { initialValue: formData.contact_tel, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Details / Content of Printing" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.detail_of_printing"
            v-decorator="[
              'formData.detail_of_printing',
              { initialValue: formData.detail_of_printing, rules: [{ required: true, message: 'Please input your data.' }] },
            ]" />
        </a-form-item>

        <!-- Event date -->
        <a-form-item label="Deadline" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-date-picker class="mr-10" v-model="formData.deadline_date" :disabled-date="disabledDate" v-decorator="[
            'formData.deadline_date',
            { initialValue: formData.deadline_date, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
          
        </a-form-item>
        <!-- Event date -->

        
        

        <!-- Size of Video -->
        <a-form-item label="Size and Amount" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">

          <a-button type="dashed" block @click="addData">
            + Add
          </a-button>

          <span v-for="(data, i) in formData.size_of_printing">
            <a-row class="mt-10">
              <a-col :span="12" style="text-align: left;">
                {{ formData.size_of_printing.length > 1 ? i + 1 : '' }}
              </a-col>
              <a-col :span="12" style="text-align: right;">
                
                <a-button v-if="formData.size_of_printing.length > 1" type="link" class="text-center"
                  @click="removeItem(index, item)">
                  <a-icon style="font-size: 20px; color: red" type="delete" />
                </a-button>
                <!-- </a-popconfirm> -->
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="6">
                <a-select show-search placeholder="select size of printing ..." option-filter-prop="children"
                  v-model="data.sizePrinting" @change="onChangeSizePrinting(i, data.sizePrinting)">
                  <a-select-option v-for="(item, index) in optionSizePrinting" :key="'size_printing' + index"
                    :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="2" style="text-align: center;">
                <p>Amount : </p>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.amount" placeholder="enter amount..." />
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="6">
                <a-input type="number" v-model="data.width" placeholder="enter width..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="1" style="text-align: center;">
                <b>X</b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.height" placeholder="enter height..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="2" style="text-align: center;">
                <p>Unit : </p>
              </a-col>
              <a-col :span="4">
                <a-select show-search placeholder="unit ..." option-filter-prop="children" v-model="data.unitType"
                  :disabled="data.sizePrinting != 'Custom'">
                  <a-select-option v-for="(item, index) in optionUnit" :key="'type_unit' + index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <hr>

          </span>

          
        </a-form-item>
        <!-- Size of Video -->

        <!-- Type of Event -->
        <a-form-item label="Remarks" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.remark" />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <p v-if="!isformData" :style="{ color: 'grey' }">Please fill out all required fields.</p>
          <a-button type="primary" :disabled="!isformData" @click="visible = true" class="mr-10">
            Submit
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>

      </a-form>
    </a-card>
    <a-modal title="Confirm" :visible="visible" :confirm-loading="confirmLoading" @ok="submitFormBook"
      @cancel="visible = false">
      <p>Are you sure to Submit ?</p>
    </a-modal>
  </div>
</template>

<script>
const form = {
  detail_of_printing: '',
  printing_upload_file: '',
  deadline_date: '',
  size_of_printing: [
    {
      sizePrinting: 'Custom',
      width: "",
      height: "",
      amount: "",
      unitType: "cm.",
    }
  ],
  remark: '',
  contact_mail: '',
  contact_tel: '',
}
const formDateTimeEvent = {
  event_date_start: '',
  event_time_start: '',
  event_date_end: '',
  event_time_end: ''
}
const formSizeAndAmount =
{
  width: "",
  height: "",
  amount: ""
}
import authService from '../../../../services/authService';

export default {
  data() {
    return {
      formData: Object.assign({}, form),
      dateTimeEvent: Object.assign({}, formDateTimeEvent),
      optionSizePrinting: [
        { label: 'A1 59.4 x 84.1 cm.', value: 'A1' },
        { label: 'A2 42 x 59.4 cm.', value: 'A2' },
        { label: 'A3 29.7 x 44.2 cm.', value: 'A3' },
        { label: 'A4 21 x 29.7 cm.', value: 'A4' },
        { label: 'A5 14.8 x 21 cm.', value: 'A5' },
        { label: 'Custom', value: 'Custom' }
      ],
      optionUnit: [
        { label: 'cm.', value: 'cm.' },
        { label: 'inch.', value: 'inch.' },
      ],
      fileList: [],
      exmapleSizePreview: true,
      loadBtnSubmit: false,
      errorSubmit: "",
      visible: false,
      confirmLoading: false,
      curDaytBooking: 10
    };
  },

  computed: {
    isformData() {
      if (
        this.formData.detail_of_printing &&
        this.formData.deadline_date &&
        this.formData.size_of_printing.length > 0 &&
        this.formData.contact_mail &&
        this.formData.contact_tel
      ) {
        if (
          this.formData.size_of_printing.length > 0
        ) {
          let isFullFieldSizePrint = !this.hasNullOrEmptyValue(this.formData.size_of_printing);
          return isFullFieldSizePrint
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isTimeBooking() {
      if (
        this.formData.timeStart !== "" &&
        this.formData.timeEnd !== ""
      ) {
        let start = `${this.moment(this.formData.dayStart).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeStart, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let end = `${this.moment(this.formData.dayEnd).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeEnd, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let ms = this.moment(start, "DD/MM/YYYY HH:mm:ss").diff(
          this.moment(end, "DD/MM/YYYY HH:mm:ss")
        );
        if (ms > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(form));//Object.assign({}, form);
    // Priority 1: Keycloak email
    if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
      this.formData.contact_mail = this.$keycloak.tokenParsed.email;
    } else {
      // Priority 2: MSAL email
      const msalAccount = authService.getAccount();
      if (msalAccount) {
        this.formData.contact_mail = msalAccount.username || '';
      }
    }
    this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
    console.log(this.$store.state.role.RulesUser.roles)
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  watch: {
    "dateTimeEvent.event_date_start"(newValue, oldValue) {
      this.dateTimeEvent.event_date_end = newValue
    }
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/booking/pr/printing",
        })
        .catch((err) => { });
    },
    hasNullOrEmptyValue(arr) {
      return arr.some(obj => Object.values(obj).some(value => value === null || value === ''));
    },
    onChangeSizePrinting(index, data) {
      switch (data) {
        case "A1":
          this.formData.size_of_printing[index].width = 59.4
          this.formData.size_of_printing[index].height = 84.1
          this.formData.size_of_printing[index].unitType = "cm."
          break;

        case "A2":
          this.formData.size_of_printing[index].width = 42
          this.formData.size_of_printing[index].height = 59.4
          this.formData.size_of_printing[index].unitType = "cm."
          break;

        case "A3":
          this.formData.size_of_printing[index].width = 29.7
          this.formData.size_of_printing[index].height = 44.2
          this.formData.size_of_printing[index].unitType = "cm."
          break;

        case "A4":
          this.formData.size_of_printing[index].width = 21
          this.formData.size_of_printing[index].height = 29.7
          this.formData.size_of_printing[index].unitType = "cm."
          break;

        case "A5":
          this.formData.size_of_printing[index].width = 14.8
          this.formData.size_of_printing[index].height = 21
          this.formData.size_of_printing[index].unitType = "cm."
          break;

        default:
          this.formData.size_of_printing[index].width = 0
          this.formData.size_of_printing[index].height = 0
          this.formData.size_of_printing[index].unitType = "cm."
          break;
      }
    },
    addData() {
      this.formData.size_of_printing.push({
        sizePrinting: 'Custom',
        width: "",
        height: "",
        amount: "",
        unitType: "cm."
      })
    },
    async removeItem(index) {
      if (this.formData.size_of_printing.length > 1) {
        this.formData.size_of_printing.splice(index, 1);
      }
    },
    setVisibleSizePreview(value) {
      this.exmapleSizePreview = value;
    },
    beforeUpload(file) {
      this.errorFile = "";
      if (
        file.type === "image/jpg" ||
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === ".heic" ||
        file.type === "image/png"
      ) {
        this.formData.printing_upload_file = file;
        this.fileList = [...this.fileList, file];
      } else {
        this.errorFile = "Found a Problemm, please check your results.";
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    disabledDate(endEventDate) {
      let curDate = new Date();
      let limitDate = new Date();

      // add day
      curDate.setDate(curDate.getDate() + this.curDaytBooking);
      return this.moment(endEventDate).format("YYYY-MM-DD") < this.moment(curDate).format("YYYY-MM-DD");
    },
    clearForm() {
      this.formData = JSON.parse(JSON.stringify(form));// Object.assign({}, form);
      // Priority 1: Keycloak email
      if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
        this.formData.contact_mail = this.$keycloak.tokenParsed.email;
      } else {
        // Priority 2: MSAL email
        const msalAccount = authService.getAccount();
        if (msalAccount) {
          this.formData.contact_mail = msalAccount.username || '';
        }
      }
      this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
      this.$router
        .push({
          path: "/booking/pr/printing",
        })
        .catch((err) => { });
    },
    async submitFormBook() {
      this.loadBtnSubmit = true;
      this.errorSubmit = null;
      let jsonData = { ...this.formData }

      //set datetime event
      jsonData.deadline_date = this.moment(jsonData.deadline_date).format("YYYY-MM-DD") + "T" +
        this.moment(jsonData.deadline_date, "HH:mm:ss").format("HH:mm:ss") +
        "+07:00"

      jsonData.size_of_printing = jsonData.size_of_printing.map(
        data => ({
          "height": data.height + " " + data.unitType,
          "width": data.width + " " + data.unitType,
          "amount": data.amount
        })
      )
      jsonData.size_of_printing = JSON.stringify(jsonData.size_of_printing)

      console.log(jsonData)

      try {
        // Convert json to fromData because the problem when upload a file
        // Create a new FormData object
        const formData = new FormData();
        // Loop through the keys in the JSON data and add them to the FormData object
        for (const key in jsonData) {
          formData.append(key, jsonData[key]);
        }
        const response = await this.$http.post("/booking/printing/add/", formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          });
        if (response.status === 201) {
          this.clearForm();
          this.visible = false;
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.loadBtnSubmit = false;
        this.errorSubmit = error;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /booking/video/add/`,
        });
      }
    },
  },
};
</script>